function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
export const useStyles = makeStyles(theme => ({
  headerContainer: {
    paddingLeft: 12,
    paddingRight: 12,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 25,
      paddingRight: 25
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "9%",
      paddingRight: "9%"
    }
  },
  bottomSpaceContainer: {
    paddingBottom: 16
  }
}));
const TemplateRenderer = ({
  content,
  sectionComponentMapping,
  ...rest
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, content === null || content === void 0 ? void 0 : content.sections.map((section, index) => {
    const Template = sectionComponentMapping[section.sectionName];
    if (!Template) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        style: {
          margin: 100,
          textAlign: "center"
        }
      }, `Component mapping missing for ${section.sectionName}`);
    }
    return /*#__PURE__*/React.createElement(Template, _extends({
      key: index,
      content: section,
      sectionIndex: index,
      leftSpaceContainer: rest.leftSpaceContainer ? rest.leftSpaceContainer : classes.headerContainer,
      bottomSpaceContainer: rest.bottomSpaceContainer ? rest.bottomSpaceContainer : classes.bottomSpaceContainer
    }, rest), section.sectionName);
  }));
};
export default TemplateRenderer;
TemplateRenderer.propTypes = {
  content: PropTypes.object.isRequired,
  sectionComponentMapping: PropTypes.object.isRequired,
  endDate: PropTypes.number,
  optInCtaClick: PropTypes.func,
  quizCtaClick: PropTypes.func,
  disableQuizCta: PropTypes.bool,
  handleAnswerChange: PropTypes.func
};